import _ from 'lodash'
import Vue from 'vue'
import VueRouter from 'vue-router'
import TheApp from './components/the-app'
import axios from 'axios'
import store from './store'
import HeadMixin from './mixins/head'

require('./support/mixins')
require('./support/filters')

/**
 * Http
 */
const apiToken = _.preload('user.data.api_token')
const personaToken = _.preload('persona_token')

axios.defaults.headers.common = _.extend(
    apiToken ? { Authorization: `Bearer ${apiToken}` } : {},
    personaToken ? { 'X-PERSONA-TOKEN': personaToken } : {},
    {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': _.preload('csrf_token')
    }
)

/**
 * Plugins
 */
Vue.use(VueRouter)
Vue.use(require('vue-meta').default)
Vue.use(require('portal-vue').default)
Vue.use(require('vue-moment'))
Vue.use(require('vue-youtube-embed').default, { componentId: 'youtube-player' })
Vue.use(require('./plugins/error/error').default)
Vue.use(require('./plugins/laroute/laroute').default)
Vue.use(require('./plugins/lodash/lodash').default)
Vue.use(require('./plugins/validator/validator').default)

/**
 * Components
 */
Vue.component('base-address', require('./components/base-address').default)
Vue.component('base-alert', require('./components/base-alert').default)
Vue.component('base-expandable', require('./components/base-expandable').default)
Vue.component('base-form', require('./components/base-form').default)
Vue.component('base-loading', require('./components/base-loading').default)
Vue.component('base-map', require('./components/base-map').default)
Vue.component('base-pagination', require('./components/base-pagination').default)
Vue.component('base-svg', require('./components/base-svg').default)
Vue.component('callback-requests-create-button', require('./components/callback-requests-create-button').default)
Vue.component('error-modal', require('./components/error-modal').default)
Vue.component('form-item', require('./components/form-item').default)
Vue.component('grid-layout', require('./components/grid-layout').default)
Vue.component('grid-layout-item', require('./components/grid-layout-item').default)
Vue.component('input-checkbox', require('./components/input-checkbox').default)
Vue.component('input-radio', require('./components/input-radio').default)
Vue.component('input-select', require('./components/input-select').default)
Vue.component('input-text', require('./components/input-text').default)
Vue.component('recaptcha-form', require('./components/recaptcha-form').default)
Vue.component('truncate-hack', require('./components/truncate-hack').default)
Vue.component('validator-alert', require('./components/validator-alert').default)
Vue.component('with-variables', require('./components/with-variables').default)

/**
 * Router
 */
const router = new VueRouter({
    routes: [
        ...require('./routes/landing-pages').default,
        ...require('./routes/www').default
    ],
    mode: 'history',
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})

/**
 * App
 */
export default new Vue({
    mixins: [
        HeadMixin
    ],
    i18n: require('./support/i18n').default,
    store,
    router,
    render: h => h(TheApp)
})
